import { Container, Typography, Box } from "@mui/material";

const PrivacyPolicy = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>
        RocketOffer.com Privacy Policy
      </Typography>
      <Typography variant="body1" paragraph>
        Effective Date: June 2, 2025
      </Typography>

      <Box sx={{ my: 2 }}>
        <Typography variant="h6">1. Introduction</Typography>
        <Typography variant="body1" paragraph>
          Welcome to Rocket Offer. Your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your personal information.
        </Typography>
      </Box>

      <Box sx={{ my: 2 }}>
        <Typography variant="h6">2. Information We Collect</Typography>
        <Typography variant="body1" paragraph>
          In the course of providing real estate-related services, we may collect:
        </Typography>
        <ul>
          <li>Contact information (name, phone number, email, mailing address)</li>
          <li>Property details (home address, listing history, valuations)</li>
          <li>Financial information (mortgage status, estimated home value)</li>
          <li>Demographic data (age, occupation, homeownership status)</li>
          <li>Communication records (emails, texts, inquiries)</li>
          <li>Device and browsing data (IP address, cookies, analytics)</li>
        </ul>
      </Box>

      <Box sx={{ my: 2 }}>
        <Typography variant="h6">3. How We Use Your Information</Typography>
        <Typography variant="body1" paragraph>
          Your information is collected to provide services, facilitate transactions, and enhance user experience.
        </Typography>
      </Box>

      <Box sx={{ my: 2 }}>
        <Typography variant="h6">4. Data Sharing and Third-Party Disclosure</Typography>
        <Typography variant="body1" paragraph>
          We do not sell or share your personal information except where legally required or necessary for transaction facilitation.  
        </Typography>
        <Typography variant="body1" fontWeight="bold">
          All the above categories exclude text messaging originator opt-in data and consent; this information will not be shared with any third parties.
        </Typography>
      </Box>

      <Box sx={{ my: 2 }}>
        <Typography variant="h6">5. Data Security</Typography>
        <Typography variant="body1" paragraph>
          We implement security measures to protect personal data from unauthorized access.
        </Typography>
      </Box>

      <Box sx={{ my: 2 }}>
        <Typography variant="h6">6. Your Rights and Choices</Typography>
        <Typography variant="body1" paragraph>
          You may access, update, or delete your personal data, and opt out of certain communications.
        </Typography>
      </Box>

      <Box sx={{ my: 2 }}>
        <Typography variant="h6">7. Contact Us</Typography>
        <Typography variant="body1" paragraph>
          If you have questions about this Privacy Policy, contact us at [Insert Contact Information].
        </Typography>
      </Box>
    </Container>
  );
};

export default PrivacyPolicy;
